export class ErrorBlockSettings {
  constructor() {
    let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaultContainerSettings = {
      containerAlign: 'center',
      containerVertical: 'flex-start',
      containerHeight: {
        type: 'auto',
        value: 1
      },
      containerMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 5,
        marginBottom: 5
      },
      containerWidth: {
        type: '%',
        value: 100
      },
      containerPadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 10,
        paddingBottom: 10
      },
      containerBackground: '#ff9595'
    };
    const defaultListSettings = {
      ulPadding: {
        paddingLeft: 30,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      ulMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0
      },
      ulFont: {
        fontSize: 12,
        color: 'white',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      liPadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      liMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0
      },
      listItems: [],
      font: {
        fontSize: 14,
        fontWeight: '400',
        color: 'red',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      bulletType: 'bullet'
    };
    Object.assign(this, defaultContainerSettings, defaultListSettings, overrides);
  }
}
;
export const ErrorBlockTypes = {
  'Container Settings': {
    containerWidth: {
      title: 'Width',
      type: 'Size'
    },
    containerHeight: {
      title: 'Height',
      type: 'Size'
    },
    containerAlign: {
      title: 'Horizontal Align',
      type: 'FlexJustify'
    },
    containerVertical: {
      title: 'Vertical Align',
      type: 'FlexAlign'
    },
    containerBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    }
  },
  'Error List Settings': {
    ulPadding: {
      title: 'List Padding',
      type: 'Padding'
    },
    ulMargin: {
      title: 'List Margin',
      type: 'Margin'
    },
    ulFont: {
      title: 'Font',
      type: 'Font'
    },
    liPadding: {
      title: 'List Item Padding',
      type: 'Padding'
    },
    liMargin: {
      title: 'List Item Margin',
      type: 'Margin'
    }
  }
};